export const messagesConstants = {
    activateMsgs: {
        alert: "Are you sure you want to activate this user?",
        fail: "Failed to Activate",
        pending: "Activating, Please wait...",
        success: "Activated Successfully",
    },
    addEventDomainMsgs: {
        fail: "Failed to Add Event Domain",
        pending: "Adding Event Domain",
        success: "Added Event Domain Successfully",
    },
    addEventPageActionMsgs: {
        fail: "Failed to Add Page Action",
        pending: "Adding Page Action, Please wait...",
        success: "Added Page Action Successfully",
    },
    addToSlideshowMsgs: {
        alert: "Are you sure you want to add this photo to the Event Slideshow?",
        fail: "Failed to Add",
        pending: "Adding to Slideshow, Please wait...",
        success: "Added Successfully",
    },
    archiveMsgs: {
        alert: "Are you sure you want to archive this Event?",
        fail: "Failed to Archive",
        pending: "Archiving, Please wait...",
        success: "Archived Successfully",
    },
    assignMsgs: {
        alert: "Assign Photographers to this Event",
        fail: "Failed to Assign",
        pending: "Assigning, Please wait...",
        success: "Assigned Successfully",
        validation: "Event must be assigned at least to 1 Photographer",
    },
    authMsgs: {
        login: {
            fail: "Failed to Login, some information is incorrect",
            pending: "Logging in, Please wait...",
        },
        logout: { pending: "Logging out, Please wait..." },
        noAccess: "This User has no access to the dashboard",
        setPassword: {
            fail: "Failed to Set Password",
            pending: "Setting Password, Please wait...",
            success: "Set Password Successfully",
        },
        unAuthorized: "Login Session is expired",
    },
    bulkDeletePhotosMsgs: {
        alert: "Delete Photo Confirmation",
        content: "Are you sure you want to delete photos? This action cannot be undone.",
        fail: "Failed to Delete Photos",
        networkFail: "Connection lost. but we are processing your request. once the connection is restored, please verify if the photos were deleted.",
        pending: "Deleting Photos, Please wait...",
        success: "Photos Deleted Successfully",
    },
    copied: "Copied..!",
    createMsgs: {
        fail: "Failed to Create",
        pending: "Creating, Please wait...",
        success: "Created Successfully",
    },
    deactivateMsgs: {
        alert: "Are you sure you want to deactivate this user?",
        fail: "Failed to Deactivate",
        pending: "Deactivating, Please wait...",
        success: "Deactivated Successfully",
    },
    deleteMsgs: {
        alert: "Are you sure you want to delete this ? It can't be restored after deleting",
        fail: "Failed to Delete",
        pending: "Deleting, Please wait...",
        success: "Deleted Successfully",
    },
    downloadMsgs: {
        fail: "No Retouched images required for this guest yet",
        photoFail: "Failed to download photo. Please try again.",
    },
    exportMsgs: {
        fail: "Failed to Export",
        pending: "Exporting List Data",
        success: "Exported Successfully",
    },
    faceSearchMsgs: { info: "Feature is applied on photos that are uploaded after enabling it. Any uploaded photos before enabling won't be included in guest search results." },
    fail: "error",
    generateEventZipFolderMsgs: {
        alert: "Generate Event Zip Folder",
        content: {
            downloadLastGeneratedZipFolder: "Download Last Generated Zip Folder",
            folderCreationTime: "Created At: ",
            formTitle: "Enter your email to Generate zip folder & link",
            lastGenerationTime: "Completed At: ",
            regenerate: "* New Images were added to the event! Please regenerate the Folder",
        },
        fail: "Failed to Generate Event Zip Folder",
        openModel: "Opening Generate Event Zip Folder Details",
        pending: "Generating Event Zip Folder, Please wait...",
        success: "Generated Event Zip Folder Successfully",
        validation: "Please add valid Email",
    },
    inputsMsgs: {
        action: "Enter Action..!",
        date: "Enter Date..!",
        domain: "Enter Domain..!",
        email: "Enter Email..!",
        event: "Enter Event..!",
        firstName: "Enter First Name..!",
        invalidDomain: "Invalid Domain..!",
        invalidEmail: "Invalid Email..!",
        invalidName: "Invalid Name ..!",
        invalidPhoneNumber: "Invalid Phone Number ..!",
        invalidUrl: "Invalid Url..!",
        label: "Enter Label..!",
        lastName: "Enter Last Name..!",
        name: "Enter Name..!",
        notMatchingPassword: "Password is not matching..!",
        password: "Enter Password..!",
        phoneNumber: "Enter Phone Number..!",
        subject: "Enter Subject..!",
        template: "Enter Template..!",
        templateName: "Enter Template Name..!",
        text: "Enter Text..!",
        title: "Enter Title..!",
        url: "Enter Url..!",
    },
    printEventPhotoMsgs: {
        alert: "Print Event Photo",
        fail: "Failed to add photo to dropbox print folder",
        pending: "Adding Photo to dropbox print folder, Please wait...",
        success: "Photo is added to dropbox print folder successfully",
        validation: "Please add Number of Copies",
    },
    removeFromSlideshowMsgs: {
        alert: "Are you sure you want to remove this photo from the Event Slideshow?",
        fail: "Failed to Remove",
        pending: "Removing from Slideshow, Please wait...",
        success: "Removed Successfully",
    },
    resendEventPhotoMsgs: {
        alert: "Resend Event Photo",
        fail: "Failed to Send Event Photo",
        pending: "Resending Event Photo, Please wait...",
        success: "Sended Event Photo Successfully",
        validation: "Please add valid Phone Numbers & Emails",
    },
    resetPasswordMsgs: {
        alert: "Are you sure you want to send a reset password email to this user?",
        fail: "Failed to Reset Password",
        pending: "Sending Reset Password Email, Please wait...",
        success: "Sent Reset Password Email Successfully",
    },
    saveMsgs: {
        fail: "Failed to Save",
        pending: "Saving, Please wait...",
        success: "Saved Successfully",
    },
    setDefaultEventOverlayMsgs: {
        fail: "Failed to Set Default Event Overlay",
        pending: "Setting Default Event Overlay, Please wait...",
        success: "Set Default Event Overlay Successfully",
    },
    shareEventGalleryMsgs: {
        alert: "Select Guests to share Event with",
        fail: "Failed to Share Event Gallery",
        pending: "Sharing Event Gallery, Please wait...",
        success: "Shared Event Gallery Successfully",
    },
    shareHeadshotGuestMsgs: {
        fail: "Failed to Send to Guest",
        pending: "Sending to Guest, Please wait...",
        success: "Sent to Guest Successfully",
    },
    success: "success",
    unarchiveMsgs: {
        alert: "Are you sure you want to unarchived this Event?",
        fail: "Failed to Unarchive",
        pending: "Unarchiving, Please wait...",
        success: "Unarchived Successfully",
    },
    uploadEventBannerImageMsgs: {
        disabled: "Please add a valid banner image link to be able to upload banner image",
        fail: "Failed to Upload Event Banner Image",
        pending: "Uploading Event Banner Image, Please wait...",
        success: "Uploaded Event Banner Image Successfully",
    },
    uploadEventOverlayMsgs: {
        fail: "Failed to Upload Event Overlay",
        pending: "Uploading Event Overlay, Please wait...",
        success: "Uploaded Event Overlay Successfully",
        wrongFormat: "Invalid Overlay Image Format. Please upload a PNG or JPG image.",
    },
    uploadEventTemplateLogoMsgs: {
        fail: "Failed to Upload Event Template Logo",
        pending: "Uploading Event Template Logo, Please wait...",
        success: "Uploaded Event Template Logo Successfully",
    },
    uploadHeadshotRetouchedPhotoMsgs: {
        fail: "Failed to Upload Retouched Photo",
        pending: "Uploading Retouched Photo, Please wait...",
        success: "Uploaded Retouched Photo Successfully",
    },
};
